/* An NPS custom answer is whatever the model wrote, so a list or an object reads as JSON. */
export function customAnswerText(value: unknown): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return value === null || value === undefined ? '' : JSON.stringify(value);
}
